import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageService, MenuItem } from 'primeng/api';
import { CommonGlobalService } from '../../../services/common-global.service';
import { TicketsService } from '../../../services/tickets.service';
import { TicketStatusDto } from '../../../data/models/ticket-status-dto';

@Component({
  selector: 'app-service-history',
  templateUrl: './service-history.component.html',
  styleUrls: ['./service-history.component.scss'],
  providers: [MessageService]
})
export class ServiceHistoryComponent implements OnInit {
  lineName: string;

  quoteId: string;
  ticketsOfLine: any[];
  tmpid: number;
  breadItems: MenuItem[];

  notExist: boolean = false;

  constructor(private ticketsService: TicketsService, private messageService: MessageService, private activatedRoute: ActivatedRoute
    , private commonGlobalService: CommonGlobalService) { }

  ngOnInit() {
    this.lineName = this.commonGlobalService.lineName;

    this.checkUrlToGetCode();

    this.breadItems = [
      { label: 'Home', routerLink: '/' },
      { label: 'LineDetails', routerLink: '/linedetails/' + this.tmpid },
      { label: 'Line Log History' }
    ];


  }

  checkUrlToGetCode() {
    this.activatedRoute.params.subscribe(
      (params) => {
        this.tmpid = params["id"];
        let tmpip = params["quoteid"];
        if (tmpip) {
          this.quoteId = tmpip;
          this.getTickets(this.quoteId);
        }
        else {
          this.messageService.add({ severity: 'error', summary: 'ucid not retrieved', detail: 'unable to show page contents' });
        }
        return;
      }

    );
  }

  getTickets(quoteId: string) {
    
    this.ticketsService.getTicketByQuoteId(quoteId).subscribe((res: TicketStatusDto[]) => {
      if (res) {
        this.ticketsOfLine = res;

        this.notExist = false;
      }
      else {
        this.notExist = true;
        this.messageService.add({ severity: 'warn', summary: 'Get Ticket By Line Id', detail: 'No tickets for this Line , check again' });
      }

    }, (error) => {
      this.messageService.add({ severity: 'error', summary: 'Get Ticket By Line Id', detail: 'unable to get tickets of that line' });

    })
  }

  getSeverity(line: any) {

    let lineIndex = this.ticketsOfLine.findIndex(e => e.srNumber == line.srNumber);
    let status = this.commonGlobalService.getStringAtIndex(line.status, lineIndex);
    
    switch (status) {
      case 'Opened':
        return 'text-success';
      case 'Closed':
        return 'text-danger';
      case 'in-Progress':
        return 'text-warning';
    }
  }
  getLineStatus(line: any) {
    let lineIndex = this.ticketsOfLine.findIndex(e => e.srNumber == line.srNumber);
    let status = this.commonGlobalService.getStringAtIndex(line.status, lineIndex);
    return status;
  }
  
}
